import React, { useState } from 'react';
import KnowledgeLibrary from './KnowledgeLibrary';

declare var InovxLoader: any;

const TaxonomyForm: React.FC = () => {
    const [containerHeight, setContainerHeight] = useState<number>(window.innerHeight - 160);
    //make containerHeight responsive to window resize
    React.useEffect(() => {
        const handleResize = () => {
            let newContainerHeight = window.innerHeight - 160;
            if (newContainerHeight !== containerHeight) {
                // Force update to re-render the component with the new container height
                if(window.innerWidth > 1400){
                    newContainerHeight = window.innerHeight - 160;
                }else if(window.innerWidth < 1400 && window.innerWidth > 1300){
                    newContainerHeight = window.innerHeight - 160;
                }else if(window.innerWidth < 1300 && window.innerWidth > 1100){
                    newContainerHeight = window.innerHeight - 160;
                }else {
                    newContainerHeight = window.innerHeight - 160;
                }
                setContainerHeight(newContainerHeight);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [containerHeight]);
    return (
        <div className="taxonomy-container">
            <KnowledgeLibrary />
        </div>
    );
};

export default TaxonomyForm;
